import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { COMPANY, SERVICES } from "../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#040405] border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <h4 className="text-xs font-bold tracking-[0.2em] text-[#FF6B1A] uppercase mb-5">Get in touch</h4>
          <div className="space-y-3 text-sm">
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-zinc-300 hover:text-[#FF6B1A] transition-colors">
              <Mail size={16} className="text-[#FF6B1A]" /> {COMPANY.email}
            </a>
            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-3 text-zinc-300 hover:text-[#FF6B1A] transition-colors">
              <Phone size={16} className="text-[#FF6B1A]" /> {COMPANY.phone}
            </a>
            <div className="flex items-center gap-3 text-zinc-300">
              <MapPin size={16} className="text-[#FF6B1A]" /> {COMPANY.address}
            </div>
          </div>
          <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
            {[
              { Icon: Instagram, href: "https://www.instagram.com/codeflarelabs/", label: "Instagram" },
              { Icon: Facebook, href: "https://www.facebook.com/people/Codeflare-Labs/61579347762752/", label: "Facebook" },
              { Icon: Linkedin, href: "https://www.linkedin.com/company/107526666/", label: "LinkedIn" },
            ].map(({ Icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                className="w-10 h-10 rounded-full border border-white/10 bg-white/5 flex items-center justify-center text-zinc-300 hover:text-black hover:bg-gradient-to-br hover:from-[#FF6B1A] hover:to-[#3B82F6] hover:border-transparent transition-all">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-bold tracking-[0.2em] text-[#FF6B1A] uppercase mb-4">Company</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="text-zinc-400 hover:text-white">About</Link></li>
            <li><Link to="/services" className="text-zinc-400 hover:text-white">Services</Link></li>
            <li><Link data-testid="footer-link-career" to="/career" className="text-zinc-400 hover:text-white">Career</Link></li>
            <li><Link to="/contact" className="text-zinc-400 hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold tracking-[0.2em] text-[#3B82F6] uppercase mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s.key}><Link to={`/services/${s.key}`} className="text-zinc-400 hover:text-white">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold tracking-[0.2em] text-[#FF6B1A] uppercase mb-4">Legal</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-career-terms" to="/career-terms" className="text-zinc-400 hover:text-white">Career Terms & Conditions</Link></li>
            <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="text-zinc-400 hover:text-white">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-faqs" to="/faqs" className="text-zinc-400 hover:text-white">FAQs</Link></li>
            
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-zinc-500 text-center">
          © {new Date().getFullYear()} Codeflare Labs. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
